import { useState } from 'react';
import data from './data';
import { FaChevronLeft, FaChevronRight, FaQuoteRight } from 'react-icons/fa';

const Review = () => {
  const [index, setIndex] = useState(0);
  const { image, name, job, text } = data[index];

  const checkIndex = (number) => {
    if (number > data.length - 1) {
      return 0;
    }
    if (number < 0) {
      return data.length - 1;
    }
    return number;
  };

  const nextPerson = () => {
    setIndex((index) => {
      let nextIndex = index + 1;
      return checkIndex(nextIndex);
    });
  };

  const prevPerson = () => {
    setIndex((index) => {
      let prevIndex = index - 1;
      return checkIndex(prevIndex);
    });
  };

  const randomPerson = () => {
    let getRandom = Math.floor(Math.random() * data.length);
    if (getRandom === index) {
      getRandom = index + 1;
    }
    setIndex(checkIndex(getRandom));
  };

  return (
    <article className='review'>
      <div className='img-container'>
        <img src={image} alt={name} className='person-img' />
        <span className='quote-icon'>
          <FaQuoteRight />
        </span>
      </div>
      <h4 className='author'>{name}</h4>
      <p className='job'>{job}</p>
      <p className='info'>{text}</p>

      <div className='button-container'>
        <button className='prev-btn' onClick={prevPerson}>
          <FaChevronLeft />
        </button>
        <button className='next-btn' onClick={nextPerson}>
          <FaChevronRight />
        </button>
      </div>
      <button className='random-btn' onClick={randomPerson}>
        surprise me
      </button>
    </article>
  );
};

export default Review;
